import { render, staticRenderFns } from "./why.vue?vue&type=template&id=18203eb9&scoped=true&"
import script from "./why.vue?vue&type=script&lang=js&"
export * from "./why.vue?vue&type=script&lang=js&"
import style0 from "./why.vue?vue&type=style&index=0&id=18203eb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18203eb9",
  null
  
)

export default component.exports